module.exports = "<div class=\"bodywrap\">\r\n    \r\n    <div class=\"error-template\">\r\n        <h1 class=\"page_title\">Oops!</h1>\r\n        <h2>404 Not Found</h2>\r\n        <div class=\"error-details\">\r\n            Sorry, an error has occured, Requested page not found!<br>\r\n        </div>\r\n    </div>\r\n    \r\n</div>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/not-found.component.html
// module id = ./src/app/shared/not-found.component.html
// module chunks = main